import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterModule
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
  userEmail: string | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.authReady$.subscribe(() => { // Ensure auth state is resolved
      if (this.authService.isAuthenticated()) {
        this.userEmail = this.authService.getUser()?.email || '@User'; // Use 'User' as default
      } else {
        this.userEmail = 'Not Signed In'; // Or handle as appropriate for your app
      }
    });
  }

}
